import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useMobileDrawer } from '@/components/layout/mobile/mobile-drawer-context'

function MenuIcon() {
  return (
    <svg aria-hidden className="size-5" fill="none" viewBox="0 0 24 24">
      <path
        d="M4 7h16M4 12h16M4 17h16"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.8"
      />
    </svg>
  )
}

export function MobileMenuButton() {
  const { t } = useTranslation('shell')
  const drawer = useMobileDrawer()

  return (
    <button
      aria-expanded={drawer?.drawerOpen ?? false}
      aria-label={t('mobile.openNavigation')}
      className="flex size-10 items-center justify-center rounded-lg text-[var(--color-text)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-[var(--color-focus)]"
      onClick={() => drawer?.openDrawer()}
      type="button"
    >
      <MenuIcon />
    </button>
  )
}

/**
 * 移动端页面顶部横条:左侧默认导航菜单(可用 left 覆盖为返回键等),
 * 中间页面标题,右侧可选操作位。对齐设计稿的单一 52px header。
 */
export function MobilePageHeader({
  left,
  right,
  title,
}: {
  left?: ReactNode
  right?: ReactNode
  title: ReactNode
}) {
  return (
    <header className="relative grid h-[52px] shrink-0 grid-cols-[40px_minmax(0,1fr)_40px] items-center gap-1 bg-white px-2">
      <div className="flex min-w-0 items-center justify-start">{left ?? <MobileMenuButton />}</div>
      <h1 className="min-w-0 truncate px-1 text-center text-[15px] leading-5 font-semibold text-[var(--color-text-strong)]">
        {title}
      </h1>
      <div className="col-start-3 flex justify-self-end">{right ?? <span aria-hidden />}</div>
    </header>
  )
}
